import React, { useEffect, useState } from "react";
import axios from "axios";
import { BrowserView, MobileView } from "react-device-detect";
import { VictoryPie } from "victory";
import { useAuth } from "../../../../context/AuthContext";
import { useTranslation } from "react-i18next";

function UserGeneral() {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [general, setGeneral] = useState({
        total: 0,
        correct: 0,
        wrong: 0,
        successRate: 0,
    });

    const [skills, setSkills] = useState({
        1: { total: 0, correct: 0, rate: 0 }, // Listening
        2: { total: 0, correct: 0, rate: 0 }, // Writing
        4: { total: 0, correct: 0, rate: 0 }, // Reading
        5: { total: 0, correct: 0, rate: 0 }, // Speaking
    });

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = async () => {
        try {
            setLoading(true);

            const headers = {
                accept: "*/*",
                "Content-Type": "application/json",
                Authorization: "Bearer " + user.token,
            };

            const res = await axios.get(
                "https://api.heryerdeingilizce.com/api/user/Opt/MyReport",
                { headers }
            );

            let total = 0;
            let correct = 0;

            const skillStats = {
                1: { total: 0, correct: 0, rate: 0 },
                2: { total: 0, correct: 0, rate: 0 },
                4: { total: 0, correct: 0, rate: 0 },
                5: { total: 0, correct: 0, rate: 0 },
            };

            res.data.data.forEach(course => {
                course.subjects.forEach(subject => {
                    subject.answers.forEach(answer => {
                        if (answer.isDeleted) return;
                        if (answer.tagId === 3) return; // Video hariç

                        total++;

                        if (answer.isTrue) correct++;

                        if (skillStats[answer.tagId]) {
                            skillStats[answer.tagId].total++;
                            if (answer.isTrue) {
                                skillStats[answer.tagId].correct++;
                            }
                        }
                    });
                });
            });

            Object.keys(skillStats).forEach(tagId => {
                const s = skillStats[tagId];
                s.rate =
                    s.total > 0 ?
                    Math.round((s.correct / s.total) * 100)
                        : 0;
            });

            setGeneral({
                total,
                correct,
                wrong: total - correct,
                successRate:
                    total > 0 ?
                    Math.round((correct / total) * 100)
                        : 0,
            });

            setSkills(skillStats);
        } catch (err) {
            setError("Veriler yüklenirken hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    // const SkillRow = ({ title, color, stat }) => (
    //     <div className="mb-4">
    //         <div className="d-flex justify-content-between mb-1">
    //             <strong>{title}</strong>
    //             <small className="text-muted">
    //                 {stat.total} soru · {stat.correct} doğru ·{" "}
    //                 {stat.total - stat.correct} yanlış
    //             </small>
    //         </div>

    //         <div className="progress" style={{ height: 22 }}>
    //             <div
    //                 className={`progress-bar bg-${color}`}
    //                 style={{ width: `${stat.rate}%` }}
    //             >
    //                 %{stat.rate}
    //             </div>
    //         </div>
    //     </div>
    // );
    const SkillRow = ({ title, color, stat }) => (
        <div className="mb-4">
            <div className="d-flex justify-content-between mb-1">
                <strong>{title}</strong>
                <small className="text-muted">
                    {stat.total} soru · {stat.correct} doğru ·{" "}
                    {stat.total - stat.correct} yanlış
                </small>
            </div>

            <div className="progress" style={{ height: 22, backgroundColor: "#e9ecef" }}>
                <div
                    className="progress-bar"
                    style={{
                        width: `${stat.rate}%`,
                        backgroundColor: color,
                        fontWeight: "bold"
                    }}
                >
                    %{stat.rate}
                </div>
            </div>
        </div>
    );

    if (loading) return <div>Yükleniyor...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="container mt-3">
            <BrowserView>
                <div className="card shadow-sm">
                    <div className="card-header bg-white text-center">
                        <h4>Genel Rapor</h4>
                        <small className="text-muted">
                            Toplam {general.total} soru ·{" "}
                            {general.correct} doğru ·{" "}
                            {general.wrong} yanlış
                        </small>
                    </div>

                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-md-4 position-relative text-center">
                                <VictoryPie
                                    data={[
                                        { x: "Doğru", y: general.correct },
                                        { x: "Yanlış", y: general.wrong },
                                    ]}
                                    innerRadius={70}
                                    labels={() => null}
                                    colorScale={["#0d6efd", "#e9ecef"]}
                                    width={260}
                                    height={260}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform:
                                            "translate(-50%, -50%)",
                                        textAlign: "center",
                                    }}
                                >
                                    <h3>%{general.successRate}</h3>
                                    <small>Başarı</small>
                                </div>
                            </div>

                            <div className="col-md-8">

                                <SkillRow title="Reading / Okuma" color="#FF7F27" stat={skills[4]} />

                                <SkillRow
                                    title="Writing / Yazma"
                                    color="#9DC97B"
                                    stat={skills[2]}
                                />
                                <SkillRow
                                    title="Listening / Dinleme"
                                    color="#C85AC9"
                                    stat={skills[1]}
                                />
                                <SkillRow
                                    title="Speaking / Konuşma"
                                    color="#5DE5F5"
                                    stat={skills[5]}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card-footer bg-white text-center">
                        <a
                            href="/userskill"
                            className="btn btn-primary rounded-pill px-4"
                        >
                            Detayları Gör
                        </a>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div className="card shadow-sm">
                    <div className="card-header bg-white text-center">
                        <h5>Genel Rapor</h5>
                        <small>%{general.successRate} başarı</small>
                    </div>

                    <div className="card-body">
                        <SkillRow
                            title="Reading"
                            color="success"
                            stat={skills[4]}
                        />
                        <SkillRow
                            title="Writing"
                            color="primary"
                            stat={skills[2]}
                        />
                        <SkillRow
                            title="Listening"
                            color="warning"
                            stat={skills[1]}
                        />
                        <SkillRow
                            title="Speaking"
                            color="info"
                            stat={skills[5]}
                        />
                    </div>
                </div>
            </MobileView>
        </div>
    );
}

export default UserGeneral;
